@import (reference) '../../../../constants/spacing.module.less';

.items-table {
  .header-row {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
  }
}

.has-low-stock {
  background: var(--order-details--alert--error--background-color);
}

.item-image-container {
  margin: 0 auto;
}

.loading {
  margin: 0 auto;
  width: 50px;
  height: 50px;
}

.cell {
  display: flex;
  align-items: center;

  padding: @space-8 @space-16;
}

.justify-center {
  justify-content: center;
  text-align: center;
}

.justify-end {
  justify-content: flex-end;
  text-align: end;
}
